let _ = t => t,
  _t;
import styledWithTheme, { css } from 'foundations-theming/utils';
export const BaseContainer = styledWithTheme.div(_t || (_t = _`
  display: flex;
  inline-size: 100%;
  aspect-ratio: 1 / 1;
  justify-content: center;
  align-items: center;

  ${0}
`), ({
  $svgSize
}) => $svgSize && css(["svg{inline-size:", " !important;block-size:", " !important;}"], $svgSize, $svgSize));